import { render } from "./PostTransplantPancreasSectionDetailsEMROATS.vue?vue&type=template&id=1b4e2b30&scoped=true"
import script from "./PostTransplantPancreasSectionDetailsEMROATS.vue?vue&type=script&lang=js"
export * from "./PostTransplantPancreasSectionDetailsEMROATS.vue?vue&type=script&lang=js"

import "./PostTransplantPancreasSectionDetailsEMROATS.vue?vue&type=style&index=0&id=1b4e2b30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b4e2b30"],['__file',"src/components/PostTransplantPancreasSectionDetailsEMROATS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b4e2b30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b4e2b30', __exports__)) {
    api.reload('1b4e2b30', __exports__)
  }
  
  module.hot.accept("./PostTransplantPancreasSectionDetailsEMROATS.vue?vue&type=template&id=1b4e2b30&scoped=true", () => {
    api.rerender('1b4e2b30', render)
  })

}


export default __exports__